import * as msgpack from '@mta/msgpack-js-lib';

export default class B2bRight {

	static get ADMIN_MANAGE_APPLICATION() {
		return 1;
	}

	static get values() {
		return {
			'1': 'ADMIN_MANAGE_APPLICATION'
		};
	}

	static get codeValues() {
		return {
			'1': ".b2b.admin.manage_application"
		};
	}

	static getCode(val) {
		const values = this.codeValues;
		if (val in values)
			return values[val];
		throw new msgpack.MessagePackException('Invalid enum value ' + val);
	}
}

msgpack.registerClass('com.arabellesolutions.sdc.b2b.common.user.B2bRight', B2bRight);
